import Illustration from '@salesforce/design-system-react/components/illustration';
import Modal from '@salesforce/design-system-react/components/modal';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { closeErrorModal, getErrorModal } from './ErrorModalSlice';

const ErrorModal = () => {
  const dispatch = useAppDispatch();
  const errorModal = useAppSelector(getErrorModal);

  return (
    <Modal
      isOpen={errorModal.isOpen}
      // isOpen={true}
      // footer={[
      //   // <Button label="Cancel" onClick={() => dispatch(closeErrorModal)} />,
      //   <Button
      //     label="Save"
      //     variant="brand"
      //     type="submit"
      //     form="update-goal-form"
      //   />
      // ]}
      // prompt="offline"
      onRequestClose={() => dispatch(closeErrorModal())}
      // heading="Something Went Wrong"
      dismissOnClickOutside={false}
      // disableClose={true}
    >
      <Illustration
        heading={`Oops! An error occurred ...`}
        // messageBody="Please refresh your page"
        messageBody={errorModal.msg}
        name="No network"
        // path="/assets/images/illustrations/empty-state-no-results.svg#no-results"
        path="/assets/images/illustrations/lake-mountains.svg#lake-mountains"
        size="small"
        internalIllustration={true} // silenceDeprecationWarning
        className="height-100 slds-grid slds-grid_vertical slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-vertical_large"
      />
    </Modal>
  );
};

export default ErrorModal;
